import { Link } from "react-router-dom";
import { useT } from "../../i18n";

export const Footer = () => {
    const { t } = useT();
    const focusList = t("footer.focusList");

    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[#E5EAF2] bg-white mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="w-6 h-6 border border-[#0033A0] flex items-center justify-center bg-white">
                            <span className="w-2 h-2 bg-[#FFC72C]" />
                        </span>
                        <span className="font-display text-lg tracking-tight text-[#0033A0]">
                            SAR
                            <span className="inline-block w-1.5 h-1.5 bg-[#FFC72C] mx-1 align-middle rounded-sm" />
                            BOT
                        </span>
                    </div>
                    <p className="font-display text-2xl md:text-3xl leading-tight text-[#0033A0] max-w-md">
                        {t("footer.tagline")}
                    </p>
                </div>

                <div className="md:col-span-3">
                    <p className="text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-4">
                        {t("footer.sections")}
                    </p>
                    <ul className="space-y-2 text-sm text-[#595959]">
                        <li>
                            <Link
                                to="/"
                                className="hover:text-[#0033A0] transition-colors"
                                data-testid="footer-link-overview"
                            >
                                {t("footer.overview")}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/video"
                                className="hover:text-[#0033A0] transition-colors"
                                data-testid="footer-link-video"
                            >
                                {t("footer.video")}
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/gallery"
                                className="hover:text-[#0033A0] transition-colors"
                                data-testid="footer-link-gallery"
                            >
                                {t("footer.gallery")}
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-4">
                        {t("footer.focus")}
                    </p>
                    <ul className="space-y-2 text-sm text-[#595959]">
                        {focusList.map((f, i) => (
                            <li key={i}>{f}</li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="border-t border-[#E5EAF2]">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <p className="text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-3">
                            {t("footer.supervisorLabel")}
                        </p>
                        <p
                            data-testid="footer-supervisor"
                            className="font-display text-lg text-[#0033A0]"
                        >
                            {t("footer.supervisorName")}
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <p className="text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-3">
                            {t("footer.membersLabel")}
                        </p>
                        <ul
                            data-testid="footer-members"
                            className="space-y-1 text-sm text-[#0E1A2B]"
                        >
                            {t("footer.members").map((m, i) => (
                                <li key={i}>{m}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="md:col-span-5">
                        <p className="text-xs uppercase tracking-[0.22em] text-[#0033A0] mb-3">
                            {t("footer.ackLabel")}
                        </p>
                        <p
                            data-testid="footer-ack"
                            className="text-sm leading-relaxed text-[#445268]"
                        >
                            {t("footer.ackText")}
                        </p>
                    </div>
                </div>
            </div>

            <div className="border-t border-[#E5EAF2]">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#595959]">
                    <p className="font-mono">
                        © {new Date().getFullYear()} {t("footer.copyright")}
                    </p>
                    <p className="font-mono uppercase tracking-[0.18em]">
                        {t("footer.tagsBottom")}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
